module.exports = function (loadMoreButton) {
    var newsLandingList = $(loadMoreButton).closest('.news-landing-list');
    var page = $(newsLandingList).data('page');
    var query = '?Page=' + page;

    var filterDiv = $(newsLandingList).siblings().filter('.news-landing-filters');
    var contextItemId = $(filterDiv).data('contextitemid');
    if (contextItemId) {
        query = query + '&ContextItemId=' + contextItemId;
    }

    var newsCategories = $(filterDiv).find('#newsCategories').children().filter(':selected').val();
    if (newsCategories) {
        query = query + '&Categories=' + newsCategories;
    }

    var newsArticleType = $(filterDiv).find('#newsTypes').children().filter(':selected').val();
    if (newsArticleType) {
        query = query + '&Type=' + newsArticleType;
    }

    var url = '/api/news/loadmore' + query;
    $.ajax({
        url: url,
        success: function (data) {
            if (data.length > 0) {
                var newsLandingListUl = $(newsLandingList).find('.news-landing-list__list');
                $(newsLandingListUl).append(data);
                var numItems = $(newsLandingListUl).find('.news-landing-list__item').length;

                if (numItems >= $(newsLandingList).data('totalresults')) {
                    $(loadMoreButton).parent().remove();
                } else {
                    $(newsLandingList).data('page', parseInt(page) + 1);
                }
            }
        },
        error: function () {
            console.log('Failed to load more news items.');
        }
    });
}
